import { render, staticRenderFns } from "./modal-order-bank.vue?vue&type=template&id=6bb89692&"
import script from "./modal-order-bank.vue?vue&type=script&lang=js&"
export * from "./modal-order-bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports